import React from 'react'
import MaskedInput from 'react-text-mask'

interface NumberMaskedInputProps {
  numberOfDigits: number
  currency?: boolean
  inputRef?: React.Ref<any>
  [key: string]: any
}

const NumberMaskedInput = React.forwardRef<any, NumberMaskedInputProps>((props, ref) => {
  const { numberOfDigits, currency, inputRef, ...other } = props
  const mask = []
  for (let i = 0; i < numberOfDigits; i++) {
    if (currency) {
      mask.push(/(\d|\.)/)
    } else {
      mask.push(/\d/)
    }
  }

  return (
    <MaskedInput
      {...other}
      ref={(maskedInputRef: any) => {
        const inputElement = maskedInputRef?.inputElement

        // Handle the ref from MUI
        if (typeof ref === 'function') {
          ref(inputElement)
        } else if (ref) {
          ;(ref as React.MutableRefObject<any>).current = inputElement
        }

        // Handle legacy inputRef prop
        if (typeof inputRef === 'function') {
          inputRef(inputElement)
        } else if (inputRef) {
          ;(inputRef as React.MutableRefObject<any>).current = inputElement
        }
      }}
      mask={mask}
    />
  )
})

NumberMaskedInput.displayName = 'NumberMaskedInput'

export default NumberMaskedInput
